export default __webpack_public_path__ + "static/media/drink7.278c4ba8.jpg";